import { useProto } from "./ProtoContext";
import { DAYS } from "./directory";
import { Avatar } from "./ui";

// Signature Care Rhythm ring: the arc shows time since last connection against the church's rhythm.
export const RhythmAvatar = ({ person, size = 52, days }) => {
  const { rhythm } = useProto();
  const d = days ?? DAYS[person.id];
  const stroke = size > 90 ? 3 : 2.5;
  const box = size + 10;
  const r = box / 2 - stroke;
  const c = 2 * Math.PI * r;
  const frac = d === undefined ? 0 : Math.min(d / rhythm, 1);
  const color = d > rhythm ? "var(--sun)" : "var(--rhythm)";
  return (
    <span className="relative inline-flex shrink-0 items-center justify-center" style={{ width: box, height: box }} data-testid={`rhythm-ring-${person.id}`}>
      <svg width={box} height={box} className="absolute inset-0 -rotate-90" aria-hidden="true">
        <circle cx={box / 2} cy={box / 2} r={r} fill="none" stroke="var(--line)" strokeWidth={stroke} />
        <circle cx={box / 2} cy={box / 2} r={r} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeDasharray={`${c * frac} ${c}`} />
      </svg>
      <Avatar person={person} size={size} />
    </span>
  );
};
